import React from "react";
import { Link } from "react-router-dom";
import AutoSuggestProducts from "../sub/AutoSuggestProducts";
import APIUrl from "../../APIUrl";

class RentalFamiliesTab extends React.Component {
  render() {
    const { filteredFamilies, searchTerm, products, onProductSelected } =
      this.props;

    const displayedFamilies = searchTerm
      ? filteredFamilies.filter((family) =>
          family.famille.toLowerCase().includes(searchTerm.toLowerCase()),
        )
      : filteredFamilies;

    if (filteredFamilies.length === 0) {
      return (
        <div className="alert alert-info" role="alert">
          Aucune famille de location trouvée.
        </div>
      );
    }

    return (
      <>
        <div className="row mb-5">
          <div className="col-md-8">
            <div className="rental-search-container">
              <AutoSuggestProducts
                suggestions={products.filter(
                  (p) =>
                    p.famille && p.famille.toLowerCase().includes("location"),
                )}
                onSuggestionSelected={onProductSelected}
                placeholder="Search.Rental.Product"
              />
              <i className="fas fa-search rental-search-icon"></i>
            </div>
          </div>
        </div>

        <div className="row">
          {displayedFamilies.map((family, index) => {
            const imgSrc =
              APIUrl.getFamilyImg +
              family.mercurial_id +
              "/FAM_" +
              family.fam.split(".")[0] +
              "?token=" +
              APIUrl.jwtToken;

            return (
              <div
                key={index}
                className="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4"
              >
                <Link
                  to={`/home/rentals/mercurial/${family.mercurial_id}/${encodeURIComponent(family.famille)}?from=rentals`}
                  className="rental-link-nostyle"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  <div className="card h-100 rental-family-card">
                    <div className="rental-family-image-container">
                      <img
                        src={imgSrc}
                        alt={family.famille}
                        className="rental-family-image"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/images/no_image_512.png";
                        }}
                      />
                    </div>
                    <div className="card-body rental-family-card-body">
                      <h5 className="card-title rental-family-card-title">
                        {family.famille}
                      </h5>
                      <div className="rental-family-card-product-count">
                        <i className="fas fa-box rental-family-card-product-icon"></i>
                        <span>
                          {family.products.length} produit
                          {family.products.length !== 1 ? "s" : ""}
                        </span>
                      </div>
                      <div className="rental-family-card-button">
                        <span>Voir les produits</span>
                        <i className="fas fa-arrow-right rental-family-card-button-icon"></i>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>

        {displayedFamilies.length === 0 && searchTerm && (
          <div className="alert alert-warning" role="alert">
            Aucune famille de location correspondant à votre recherche.
          </div>
        )}
      </>
    );
  }
}

export default RentalFamiliesTab;
